export default __webpack_public_path__ + "static/FuturaBT-Book-5433b576d5c83a2afde23fdb61b28e20.eot";